<script>
    import { createEventDispatcher } from 'svelte';
    import { Shadow } from 'svelte-loading-spinners';
    import { chart } from "svelte-apexcharts";
    import Draggable from './Draggable.svelte';
	  const dispatch = createEventDispatcher();
    export let data;
    export let nodata;
 
    function format(num) {
		if (max >= 1000000) {
            return num ? `${(num / 1e6).toFixed(2)} M` : '';
	    } else {
            return num;
        }};
    function area(num) {
        return num ? `${(num / 1e6).toFixed(2)} km²` : '';
    };

    $: allYears = data?.data || 0
    $: pop1975 = allYears[0]?.count || 0
    $: pop1990 = allYears[1]?.count || 0
    $: pop2000 = allYears[2]?.count || 0
    $: pop2015 = allYears[3]?.count || 0

    $: popdata = [pop1975, pop1990, pop2000, pop2015]
    $: max = Math.max(pop2015,pop2000,pop1990,pop1975)

    $: options = {
        colors: ['#2A4365'],
          series: [{
          name: 'Population',
          data: popdata
        }],
          chart: {
          height: 250,
          type: 'bar',
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            dataLabels: {
              position: 'top',
            },
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return format(val);
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ["#000000"],
            fontFamily: 'Calibri Light, sans-serif'
          }
        },
        xaxis: {
          categories: ["1975", "1990", "2000", "2015"],
          position: 'bottom',
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          tooltip: {
            enabled: false,
          }
        },
        yaxis: {
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: true,
            formatter: function (val) {
              return format(val);
            }
          }
        }
        };

</script>

<Draggable>
  <div id="dashboard">
    <form action="/action_page.php" class="dashboard-container">
        <p>Population Count</p>
        {#if data}
        <label class=label><strong>Area:</strong> {area(data["area_m2"])}</label>
        <div class="chart" use:chart={options}/>
        {:else}
        {#if nodata == 'Error'}
        <p class="nodata">Data not available</p>
        {:else}
        <div class="spinner-item" title="Shadow">
            <Shadow size="50" color="#2A4365" unit="px" duration="3s"></Shadow>
        </div>
        <p class="load">loading...</p>
        {/if}
        {/if}
        <button type="button" class="close-dashboard" title="close" on:click={() => dispatch("close")}>x</button>
    </form>
  </div>
</Draggable>

<style>
    p {
      font-family: Calibri Light, sans-serif;
      font-weight: bold;
      font-size: 20px;
      margin-top: 15px;
    }
    .load {
      position: relative;
      font-size: 18px;
      font-weight: normal;
      padding: 30px;
    }
    .nodata {
      position: relative;
      font-size: 18px;
      font-weight: normal;
      padding: 30px;
      top: 40px;
    }
    .spinner-item {
      display: flex;
      height: 150px;
      justify-content: center;
      align-items: center;
      border: none;
      box-shadow: none;
    }
    .label {
      font-family: Calibri Light, sans-serif;
      font-size: 15px;
    }
    .close-dashboard {
      position: absolute;
      top: 0;
      right: 5px;
      color: #696969;
      cursor: pointer;
      width: 20px;
      height: 20px;
      font-family: Calibri Light, sans-serif;
      font-weight: 900;
      font-size: 20px;
      border: none;
      padding: 0;
      margin: 0;
      text-align: center;
    }
    .chart {
      margin-left: 48px;
      width: 300px;
      height: 270px;
      padding-top: 10px;
      box-sizing: border-box;
      border-width: 0;
      box-shadow: none;
      font-family: Calibri Light, sans-serif;
    }
    @media only screen and (max-width: 40em) {
      .dashboard-container {
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        height: 100%;
        max-width: none;
        max-height: none;
      }
      .chart {
        position: relative;
        left: 50%;
        transform: translate(-50%);
        margin-left: 0;
      }
      .close-dashboard {
        top: 10px;
        right: 10px;
      }
    }

</style>